import React, { useState, useEffect } from 'react';
import styles from './GuestPage.module.scss';

function GuestWaitingMessageBlock({ updateToken }) {
  const [paragraph1, setParagraph1] = useState('');
  const [paragraph2, setParagraph2] = useState('');
  const [customMessage, setCustomMessage] = useState('');
  const [inQueue, setInQueue] = useState(true);

  useEffect(() => {
    if (!updateToken) return;

    setParagraph1('');
    setParagraph2('');
    setCustomMessage('');

    updateToken.position === 0 ||
    (updateToken.status && !updateToken.status.startsWith('waiting'))
      ? setInQueue(false)
      : setInQueue(true);

    if (updateToken.position === 0) {
      setParagraph1('You have been served.');
      setParagraph2('Happy to have you in our event. Thank you!');
    } else if (
      updateToken.status &&
      !updateToken.status.startsWith('waiting')
    ) {
      setParagraph1('You are now not in this event.');
      setParagraph2('Please join for a turn.');
    } else if (updateToken.position === 1) {
      setParagraph1('There is no one ahead of you.');
      setParagraph2('Please wait to be notified by the queue manager.');
    }
    if (updateToken.status && updateToken.status.includes('notified')) {
      setCustomMessage(updateToken.notifyMessage);
    }
  }, [updateToken]);

  if (!updateToken) return null;

  return inQueue ? (
    <div className={'center-horizontally()'}>
      <h5 className={'my-3'}>Your position is {updateToken.position}</h5>
      <p className={styles['info-message']}>{paragraph1}</p>
      <p className={customMessage ? styles['custom-message'] : ''}>
        {customMessage ? customMessage : paragraph2}
      </p>
      <div className={'d-flex my-4 justify-content-evenly'}>
        <div className={styles['waiting-time-info']}>
          <p>Expected arrival time</p>
          {updateToken.estWaitTime ? (
            <h3>{updateToken.expTime}</h3>
          ) : (
            <h3>Not available</h3>
          )}
        </div>
        <div className={styles['waiting-time-info']}>
          <p>Estimated wait time</p>
          {updateToken.estWaitTime ? (
            <h3>{updateToken.estWaitTime} mins</h3>
          ) : (
            <h3>Not available</h3>
          )}
        </div>
      </div>
      {!updateToken.estWaitTime && (
        <p
          style={{
            fontSize: '0.875rem',
            color: '#6c757d',
            marginTop: '8px',
          }}
        >
          The first user will be served soon, and we will provide an estimated
          wait time shortly.
        </p>
      )}
    </div>
  ) : (
    <div className={styles['message-update']}>
      <p className={styles['info-message']}>{paragraph1}</p>
      <p className={customMessage ? styles['custom-message'] : ''}>
        {customMessage && customMessage}
      </p>
      <p>{paragraph2}</p>
    </div>
  );
}

export default GuestWaitingMessageBlock;
